<div
  class="debug-panel"
  [style.left.px]="posX"
  [style.top.px]="posY"
>
  <div class="debug-header" (mousedown)="onHeaderMouseDown($event)">
    <span class="debug-title">HLS Debug</span>
    <button class="debug-close" (click)="closed.emit()">&#x2715;</button>
  </div>

  <div class="debug-body">
    <!-- ContentControlHLSProvider -->
    <div class="debug-section-header" (click)="toggleSection('hls')">
      {{ collapsedSections['hls'] ? '▶' : '▼' }} HLS SNAPSHOT
    </div>
    <div *ngIf="!collapsedSections['hls'] && hlsSnapshot">
      <!-- Time & Playback -->
      <div class="debug-section">
        <div class="debug-section-title">Time &amp; Playback</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentTimeSecs']">currentTimeSecs</span>
          <span class="debug-value">{{ hlsSnapshot.currentTimeSecs | number:'1.3-3' }}<br><small>{{ formatTimestamp(hlsSnapshot.currentTimeSecs * 1000) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['rawCurrentTimeSecs']">rawCurrentTimeSecs</span>
          <span class="debug-value">{{ hlsSnapshot.rawCurrentTimeSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(hlsSnapshot.rawCurrentTimeSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['durationSecs']">durationSecs</span>
          <span class="debug-value">{{ hlsSnapshot.durationSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(hlsSnapshot.durationSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['playingDate']">playingDate</span>
          <span class="debug-value">{{ hlsSnapshot.playingDateIso }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['paused']">paused</span>
          <span class="debug-value">{{ hlsSnapshot.paused }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['muted']">muted</span>
          <span class="debug-value">{{ hlsSnapshot.muted }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['playbackRate']">playbackRate</span>
          <span class="debug-value">{{ hlsSnapshot.playbackRate }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['readyState']">readyState</span>
          <span class="debug-value">{{ hlsSnapshot.readyState }}</span>
        </div>
      </div>

      <!-- Frame Rate -->
      <div class="debug-section">
        <div class="debug-section-title">Frame Rate</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['videoFps']">videoFps</span>
          <span class="debug-value">{{ hlsSnapshot.videoFps }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['oneFrameSecs']">oneFrameSecs</span>
          <span class="debug-value">{{ hlsSnapshot.oneFrameSecs | number:'1.6-6' }}<br><small>{{ formatSecsTimecode(hlsSnapshot.oneFrameSecs) }}</small></span>
        </div>
      </div>

      <!-- Manifest & Buffer -->
      <div class="debug-section">
        <div class="debug-section-title">Manifest &amp; Buffer</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isManifestParsed']">isManifestParsed</span>
          <span class="debug-value">{{ hlsSnapshot.isManifestParsed }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['loadTimeMs']">loadTimeMs</span>
          <span class="debug-value">{{ hlsSnapshot.loadTimeMs }}<br><small>{{ formatTimestamp(hlsSnapshot.loadTimeMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['maxBufferLengthSecs']">maxBufferLengthSecs</span>
          <span class="debug-value">{{ hlsSnapshot.maxBufferLengthSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(hlsSnapshot.maxBufferLengthSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['segmentDurationSecs']">segmentDurationSecs</span>
          <span class="debug-value">{{ hlsSnapshot.segmentDurationSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(hlsSnapshot.segmentDurationSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['segmentsCount']">segmentsCount</span>
          <span class="debug-value">{{ hlsSnapshot.segmentsCount }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['levelTargetDuration']">levelTargetDuration</span>
          <span class="debug-value">{{ hlsSnapshot.levelTargetDuration | number:'1.3-3' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['levelFragmentCount']">levelFragmentCount</span>
          <span class="debug-value">{{ hlsSnapshot.levelFragmentCount }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['levelTotalDuration']">levelTotalDuration</span>
          <span class="debug-value">{{ hlsSnapshot.levelTotalDuration | number:'1.3-3' }}</span>
        </div>
      </div>

      <!-- Fragments -->
      <div class="debug-section">
        <div class="debug-section-title">Fragments</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['hasFragments']">hasFragments</span>
          <span class="debug-value">{{ hlsSnapshot.hasFragments }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['hasLevelDetails']">hasLevelDetails</span>
          <span class="debug-value">{{ hlsSnapshot.hasLevelDetails }}</span>
        </div>
        <div class="debug-row debug-row--expandable" (click)="toggleField('activeFrag')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['activeFrag']">activeFrag {{ expandedFields['activeFrag'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['activeFrag']" class="debug-json">{{ hlsSnapshot.activeFragJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('firstFragment')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['firstFragment']">firstFragment {{ expandedFields['firstFragment'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['firstFragment']" class="debug-json">{{ hlsSnapshot.firstFragmentJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('lastFragment')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['lastFragment']">lastFragment {{ expandedFields['lastFragment'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['lastFragment']" class="debug-json">{{ hlsSnapshot.lastFragmentJson }}</pre>
      </div>

      <!-- Live -->
      <div class="debug-section">
        <div class="debug-section-title">Live</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['liveSyncPosition']">liveSyncPosition</span>
          <span class="debug-value">{{ hlsSnapshot.liveSyncPosition | number:'1.3-3' }}</span>
        </div>
      </div>

      <!-- Dimensions -->
      <div class="debug-section">
        <div class="debug-section-title">Dimensions</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['widthPx']">widthPx</span>
          <span class="debug-value">{{ hlsSnapshot.widthPx }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['heightPx']">heightPx</span>
          <span class="debug-value">{{ hlsSnapshot.heightPx }}</span>
        </div>
      </div>

      <!-- Tracks -->
      <div class="debug-section">
        <div class="debug-section-title">Tracks</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['audioTrackNames']">audioTrackNames</span>
          <span class="debug-value">{{ hlsSnapshot.audioTrackNames }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['subtitleTrackNames']">subtitleTrackNames</span>
          <span class="debug-value">{{ hlsSnapshot.subtitleTrackNames }}</span>
        </div>
      </div>
    </div>

    <!-- Live Timeline -->
    <div class="debug-section-header" (click)="toggleSection('timeline')">
      {{ collapsedSections['timeline'] ? '▶' : '▼' }} Live Timeline
    </div>
    <div *ngIf="!collapsedSections['timeline'] && timelineSnapshot">
      <!-- Timeline State -->
      <div class="debug-section">
        <div class="debug-section-title">Timeline State</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineBlockDurationSecs']">timelineBlockDurationSecs</span>
          <span class="debug-value">{{ timelineSnapshot.timelineBlockDurationSecs }}<br><small>{{ formatSecsTimecode(timelineSnapshot.timelineBlockDurationSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isVideoTimelineFit']">isVideoTimelineFit</span>
          <span class="debug-value">{{ timelineSnapshot.isVideoTimelineFit }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isFitSegment']">isFitSegment</span>
          <span class="debug-value">{{ timelineSnapshot.isFitSegment }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isLiveZoomMode']">isLiveZoomMode</span>
          <span class="debug-value">{{ timelineSnapshot.isLiveZoomMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedSegmentId']">selectedSegmentId</span>
          <span class="debug-value">{{ timelineSnapshot.selectedSegmentId ?? 'none' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineMode']">timelineMode</span>
          <span class="debug-value">{{ timelineSnapshot.timelineMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['oneFrameSecs']">oneFrameSecs</span>
          <span class="debug-value">{{ timelineSnapshot.oneFrameSecs | number:'1.6-6' }}<br><small>{{ formatSecsTimecode(timelineSnapshot.oneFrameSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['videoFps']">videoFps</span>
          <span class="debug-value">{{ timelineSnapshot.videoFps }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['pixelsPerSecond']">pixelsPerSecond</span>
          <span class="debug-value">{{ timelineSnapshot.pixelsPerSecond | number:'1.3-3' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoTime']">currentVideoTime</span>
          <span class="debug-value">{{ timelineSnapshot.currentVideoTime | number:'1.3-3' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoPlayTimeSecs']">currentVideoPlayTimeSecs</span>
          <span class="debug-value">{{ timelineSnapshot.currentVideoPlayTimeSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(timelineSnapshot.currentVideoPlayTimeSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['tlSegmentsCount']">segmentsCount</span>
          <span class="debug-value">{{ timelineSnapshot.segmentsCount }}</span>
        </div>
      </div>

    </div>

    <!-- Live ViewModel -->
    <div class="debug-section-header" (click)="toggleSection('vm')">
      {{ collapsedSections['vm'] ? '▶' : '▼' }} Live ViewModel
    </div>
    <div *ngIf="!collapsedSections['vm'] && vmSnapshot">
      <!-- Delay & Timing -->
      <div class="debug-section">
        <div class="debug-section-title">Delay &amp; Timing</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['setDelayMs']">setDelayMs</span>
          <span class="debug-value">{{ vmSnapshot.setDelayMs }}<br><small>{{ formatMsTimecode(vmSnapshot.setDelayMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['allowedDeviationMs']">allowedDeviationMs</span>
          <span class="debug-value">{{ vmSnapshot.allowedDeviationMs }}<br><small>{{ formatMsTimecode(vmSnapshot.allowedDeviationMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['hlsStreamDurationMs']">hlsStreamDurationMs</span>
          <span class="debug-value">{{ vmSnapshot.hlsStreamDurationMs | number:'1.0-0' }}<br><small>{{ formatMsTimecode(vmSnapshot.hlsStreamDurationMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['videoWithoutCutDirectivesWithInsertsMs']">videoWithoutCutDirectivesWithInsertsMs</span>
          <span class="debug-value">{{ vmSnapshot.videoWithoutCutDirectivesWithInsertsMs | number:'1.0-0' }}<br><small>{{ formatMsTimecode(vmSnapshot.videoWithoutCutDirectivesWithInsertsMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['overUnderRunMs']">overUnderRunMs</span>
          <span class="debug-value">{{ vmSnapshot.overUnderRunMs | number:'1.0-0' }}<br><small>{{ formatMsTimecode(vmSnapshot.overUnderRunMs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoTimeUtcMs']">currentVideoTimeUtcMs</span>
          <span class="debug-value">{{ vmSnapshot.currentVideoTimeUtcMs }}<br><small>{{ formatTimestamp(vmSnapshot.currentVideoTimeUtcMs) }}</small></span>
        </div>
      </div>

      <!-- State -->
      <div class="debug-section">
        <div class="debug-section-title">State</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['showDebugPanel']">showDebugPanel</span>
          <span class="debug-value">{{ vmSnapshot.showDebugPanel }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['vmSegmentsCount']">segmentsCount</span>
          <span class="debug-value">{{ vmSnapshot.segmentsCount }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isAudioMuted']">isAudioMuted</span>
          <span class="debug-value">{{ vmSnapshot.isAudioMuted }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isAudioForcedMuted']">isAudioForcedMuted</span>
          <span class="debug-value">{{ vmSnapshot.isAudioForcedMuted }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedAudioOption']">selectedAudioOption</span>
          <span class="debug-value">{{ vmSnapshot.selectedAudioOption }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineMode']">timelineMode</span>
          <span class="debug-value">{{ vmSnapshot.timelineMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isFitSegment']">isFitSegment</span>
          <span class="debug-value">{{ vmSnapshot.isFitSegment }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isLiveZoomMode']">isLiveZoomMode</span>
          <span class="debug-value">{{ vmSnapshot.isLiveZoomMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isFragmentDialogOpen']">isFragmentDialogOpen</span>
          <span class="debug-value">{{ vmSnapshot.isFragmentDialogOpen }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isEffectAreaDragging']">isEffectAreaDragging</span>
          <span class="debug-value">{{ vmSnapshot.isEffectAreaDragging }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isEffectAreaResizing']">isEffectAreaResizing</span>
          <span class="debug-value">{{ vmSnapshot.isEffectAreaResizing }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isVideoAudioTrack']">isVideoAudioTrack</span>
          <span class="debug-value">{{ vmSnapshot.isVideoAudioTrack }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isVideoPaused']">isVideoPaused</span>
          <span class="debug-value">{{ vmSnapshot.isVideoPaused }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isVideoTimelineFit']">isVideoTimelineFit</span>
          <span class="debug-value">{{ vmSnapshot.isVideoTimelineFit }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedSegmentId']">selectedSegmentId</span>
          <span class="debug-value">{{ vmSnapshot.selectedSegmentId ?? 'none' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedTimelineZoomStepIndex']">selectedTimelineZoomStepIndex</span>
          <span class="debug-value">{{ vmSnapshot.selectedTimelineZoomStepIndex }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedTimelineBlockDuration']">selectedTimelineBlockDuration</span>
          <span class="debug-value">{{ vmSnapshot.selectedTimelineBlockDuration }}</span>
        </div>
      </div>

      <!-- Zoom -->
      <div class="debug-section">
        <div class="debug-section-title">Zoom</div>
        <div class="debug-row debug-row--expandable" (click)="toggleField('availableTimelineZoomSteps')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['availableTimelineZoomSteps']">availableTimelineZoomSteps {{ expandedFields['availableTimelineZoomSteps'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['availableTimelineZoomSteps']" class="debug-json">{{ vmSnapshot.availableTimelineZoomStepsJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('timelineZoomSteps')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineZoomSteps']">timelineZoomSteps {{ expandedFields['timelineZoomSteps'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['timelineZoomSteps']" class="debug-json">{{ vmSnapshot.timelineZoomStepsJson }}</pre>
      </div>

      <!-- Audio & Subtitles -->
      <div class="debug-section">
        <div class="debug-section-title">Audio &amp; Subtitles</div>
        <div class="debug-row debug-row--expandable" (click)="toggleField('audioOptions')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['audioOptions']">audioOptions {{ expandedFields['audioOptions'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['audioOptions']" class="debug-json">{{ vmSnapshot.audioOptionsJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('subtitleOptions')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['subtitleOptions']">subtitleOptions {{ expandedFields['subtitleOptions'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['subtitleOptions']" class="debug-json">{{ vmSnapshot.subtitleOptionsJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('selectedSubtitleOptions')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedSubtitleOptions']">selectedSubtitleOptions {{ expandedFields['selectedSubtitleOptions'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['selectedSubtitleOptions']" class="debug-json">{{ vmSnapshot.selectedSubtitleOptionsJson }}</pre>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['availableAudioTracksKeys']">availableAudioTracks (keys)</span>
          <span class="debug-value">{{ vmSnapshot.availableAudioTracksKeys }}</span>
        </div>
      </div>

      <!-- Events -->
      <div class="debug-section">
        <div class="debug-section-title">Events</div>
        <div class="debug-row debug-row--expandable" (click)="toggleField('multiEventsSelectedIds')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['multiEventsSelectedIds']">multiEventsSelectedIds {{ expandedFields['multiEventsSelectedIds'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['multiEventsSelectedIds']" class="debug-json">{{ vmSnapshot.multiEventsSelectedIdsJson }}</pre>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['activeEventsCount']">activeEvents (count)</span>
          <span class="debug-value">{{ vmSnapshot.activeEventsCount }}</span>
        </div>
        <div class="debug-row debug-row--expandable" (click)="toggleField('activeEvents')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['activeEvents']">activeEvents (detail) {{ expandedFields['activeEvents'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['activeEvents']" class="debug-json">{{ vmSnapshot.activeEventsJson }}</pre>
        <div class="debug-row debug-row--expandable" (click)="toggleField('keyframeChangeHolder')">
          <span class="debug-label" [attr.data-tooltip]="tooltips['keyframeChangeHolder']">keyframeChangeHolder {{ expandedFields['keyframeChangeHolder'] ? '▼' : '▶' }}</span>
        </div>
        <pre *ngIf="expandedFields['keyframeChangeHolder']" class="debug-json">{{ vmSnapshot.keyframeChangeHolderJson }}</pre>
      </div>
    </div>
  </div>
</div>
